module.exports = __webpack_public_path__ + "img/brand-vk.25cc78e9.svg";